// Review-presence predicates shared by every admin wash-history surface.
//
// F-01 (phase 47 context): `washReview` is always truthy — the backend
// serializes an unreviewed wash's review sub-document as `{ tags: [] }`, never
// as `null`/`undefined`. A bare `wash.washReview &&` check therefore always
// passes and must never be used to decide whether a wash "has" a review.
//
// `addWashReview` (ukar-backend/src/controllers/washController.js) writes
// `createdAt` on every accepted submission, including the skip path (rating 0,
// no message, no tags). Rows from before that was guaranteed can carry a
// rating/message/tags with no `createdAt`, so this mirrors the backend's own
// `washAlreadyHasReview` exactly — the UI must never show "no review" for one
// the server already counts as submitted.
import { IWashReview, IPartnerReview } from "../../types/wash.types";

export function hasCustomerReview(wash: { washReview?: IWashReview }): boolean {
  const r = wash.washReview;
  if (!r) return false;
  if (r.createdAt) return true;
  if (typeof r.rating === "number" && r.rating > 0) return true;
  if (typeof r.message === "string" && r.message.trim()) return true;
  return Array.isArray(r.tags) && r.tags.length > 0;
}

export function hasPartnerReview(wash: { partnerReview?: IPartnerReview }): boolean {
  return !!wash.partnerReview?.reviewedBy;
}

// rating 0 is the skip/dismiss sentinel (see washModel.js), never a real score.
export function isRatingSkipped(review?: { rating?: number }): boolean {
  return !review?.rating;
}
